import GetLink from './GetLink';

export default GetLink;
